/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoXperTgeRequest model module.
 * @module model/WalletControllerDtoXperTgeRequest
 * @version 1.0
 */
class WalletControllerDtoXperTgeRequest {
    /**
     * Constructs a new <code>WalletControllerDtoXperTgeRequest</code>.
     * @alias module:model/WalletControllerDtoXperTgeRequest
     */
    constructor() { 
        
        WalletControllerDtoXperTgeRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoXperTgeRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoXperTgeRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoXperTgeRequest} The populated <code>WalletControllerDtoXperTgeRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoXperTgeRequest();

            if (data.hasOwnProperty('xperQuantity')) {
                obj['xperQuantity'] = ApiClient.convertToType(data['xperQuantity'], 'Number');
            }
            if (data.hasOwnProperty('twofaNo')) {
                obj['twofaNo'] = ApiClient.convertToType(data['twofaNo'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoXperTgeRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoXperTgeRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['twofaNo'] && !(typeof data['twofaNo'] === 'string' || data['twofaNo'] instanceof String)) {
            throw new Error("Expected the field `twofaNo` to be a primitive type in the JSON string but got " + data['twofaNo']);
        }

        return true;
    }


}



/**
 * @member {Number} xperQuantity
 */
WalletControllerDtoXperTgeRequest.prototype['xperQuantity'] = undefined;

/**
 * @member {String} twofaNo
 */
WalletControllerDtoXperTgeRequest.prototype['twofaNo'] = undefined;






export default WalletControllerDtoXperTgeRequest;

